<ic-progress-bar class="loading-bar" mode="query" [loading]="loading" />

<div class="ic-calendar-actions">
	<div class="view-range-actions">
		<ic-chip-button data-test="previous-period-button" (action)="onPreviousClicked()">
			@switch (viewType$ | async) {
				@case (viewTypeEnum.WEEK) {
					{{ "actions.previous" | translate }}
				}
				@case (viewTypeEnum.MONTH) {
					{{ "actions.previousFrenchMasculine" | translate }}
				}
			}
		</ic-chip-button>

		<h1>
			@if (viewType$ | async; as viewType) {
				<time data-test="current-period">
					{{ viewDate$ | async | calendarDate: viewType + "ViewTitle" : localeFormat : weekStartsOn }}
				</time>
			}
		</h1>

		<ic-chip-button data-test="next-period-button" (action)="onNextClicked()">
			@switch (viewType$ | async) {
				@case (viewTypeEnum.WEEK) {
					{{ "actions.next" | translate }}
				}
				@case (viewTypeEnum.MONTH) {
					{{ "actions.nextFrenchMasculine" | translate }}
				}
			}
		</ic-chip-button>
	</div>

	<div class="view-type-actions">
		<ic-selector
			data-test="view-type-selector"
			[formControl]="viewTypeSelector"
			[isUnsettable]="false"
			[items]="viewTypes"
		>
			<ng-template #item let-item>
				@switch (item) {
					@case (viewTypeEnum.WEEK) {
						{{ viewTypeLabels.week }}
					}
					@case (viewTypeEnum.MONTH) {
						{{ viewTypeLabels.month }}
					}
				}
			</ng-template>
		</ic-selector>
	</div>
</div>

<div class="ic-calendar">
	@if (debouncedViewType$ | async; as viewType) {
		<div class="ic-calendar-content">
			@switch (viewType) {
				@case (viewTypeEnum.MONTH) {
					<ic-calendar-month-view-component
						class="calendar-view"
						[activeDay]="detailDay"
						[events]="events"
						[locale]="localeFormat"
						[viewDate]="debounceViewDate$ | async"
						(dayClicked)="dayClicked($event)"
						(eventClicked)="showDetail($event)"
					>
						@if (calendarEventTemplate; as event) {
							<ng-template #cellTmpl let-event>
								<ng-template
									[ngTemplateOutlet]="calendarEventTemplate"
									[ngTemplateOutletContext]="{ $implicit: event }"
								/>
							</ng-template>
						}
					</ic-calendar-month-view-component>
				}
				@case (viewTypeEnum.WEEK) {
					<ic-calendar-week-view-component
						#calendar
						class="calendar-view"
						[activeDay]="detailDay"
						[events]="events"
						[locale]="localeFormat"
						[viewDate]="debounceViewDate$ | async"
						[weekStartsOn]="weekStartsOn"
						(eventClicked)="showDetail($event)"
					>
						@if (calendarWeekEventTemplate) {
							<ng-template #weekEventTmpl let-eventClicked="eventClicked" let-weekEvent>
								<ng-template
									[ngTemplateOutlet]="calendarWeekEventTemplate"
									[ngTemplateOutletContext]="{ $implicit: weekEvent, eventClicked: eventClicked }"
								/>
							</ng-template>
						}
					</ic-calendar-week-view-component>
				}
			}
		</div>
	}

	@if (detailShown) {
		<div class="ic-calendar-detail ic-scroll-bar">
			<ui-icon-button class="close" icon="fa fa-times" (action)="closeDetail()" />
			@if (detailDay) {
				<ng-template [ngTemplateOutlet]="dayDetailTemplate" [ngTemplateOutletContext]="{ $implicit: detailDay }" />
			}
			@if (detailEvent) {
				<ng-template [ngTemplateOutlet]="eventDetailTemplate" [ngTemplateOutletContext]="{ $implicit: detailEvent }" />
			}
		</div>
	}
</div>
